import Image from 'next/image'
import { usePreloadedImage } from 'src/hooks/usePreloadImage'
import { useLayeredCrossfade } from 'src/hooks/useLayeredCrossfade'
import type { Track } from 'src/types/domain/Track'

type Props = Readonly<{
  hoverTrack: Track | null
}>

export function DynamicTrackBackground({ hoverTrack }: Props) {
  const { topLayer, contentA, contentB } = useLayeredCrossfade<Track>(hoverTrack, 250)
  const isLoadedA = usePreloadedImage(contentA?.background || null)
  const isLoadedB = usePreloadedImage(contentB?.background || null)

  const renderLayer = (track: Track | null, isLoaded: boolean) => {
    if (!track) return null

    return (
      <Image
        alt={track.name}
        className={`object-cover transition-opacity duration-500 ease-in-out ${
          isLoaded ? 'opacity-100' : 'opacity-0'
        }`}
        fill
        priority
        sizes="100vw"
        src={track.background}
      />
    )
  }

  return (
    <div className="dynamic-background-container">
      <div
        className="dynamic-background-image layer-a"
        style={{
          opacity: topLayer === 'A' ? 1 : 0,
          transition: 'opacity 0.4s ease-in-out',
          zIndex: topLayer === 'A' ? 2 : 1
        }}
      >
        {renderLayer(contentA, isLoadedA)}
      </div>

      <div
        className="dynamic-background-image layer-b"
        style={{
          opacity: topLayer === 'B' ? 1 : 0,
          transition: 'opacity 0.4s ease-in-out',
          zIndex: topLayer === 'B' ? 2 : 1
        }}
      >
        {renderLayer(contentB, isLoadedB)}
      </div>
    </div>
  )
}
